import React, { useState } from 'react';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
import { UserForm } from './UserForm';
import environment from '../../lib/RelayUtils';
import { fold, none, some } from 'fp-ts/lib/Option';
import * as UserAddMutation from '../../mutations/UserAddMutation';
import { pipe } from 'fp-ts/lib/pipeable';
import { withRouter } from 'react-router-dom';

export const UserCreate = withRouter(({history}) => {
	const [serverError, setServerError] = useState(null);
	const [snackbarMessage, setSnackbarMessage] = useState(none);
	const onSubmit = data => {
		UserAddMutation.commit(environment, data, (error: ?Error) => {
			if (error) {
				setServerError({
					field: 'email',
					type: 'required',
					message: 'Email уже занят'
				});
			} else {
				setSnackbarMessage(some('Пользователь успешно создан'));
				history.push(`/users`)
			}
		});
	};

	const handleCloseSnackbar = () => setSnackbarMessage(none);

	return (
		<Paper style={{ width: '100%', padding: 16 }}>
			<UserForm user={{}} isCreation={true} onSubmit={onSubmit} serverError={serverError} />
			{pipe(
				snackbarMessage,
				fold(
					() => null,
					message => (
						<Snackbar
							open={true}
							bodyStyle={{ backgroundColor: '#ef426f', height: 'auto', lineHeight: '16px', padding: 12, whiteSpace: 'pre-line' }}
							message={message}
							onRequestClose={handleCloseSnackbar}
						/>
					),
				),
			)}
		</Paper>
	);
});



// WEBPACK FOOTER //
// src/components/users/UserCreate.js